<template>
	<div class="functionalArea">
		<div class="functionArea_item" v-for="(item, index) in functionalAreaList" :key="index">
			<i class="iconfont icon-icon_check2"></i>
			<span class="functionArea_item_text">{{item.title}}</span>
		</div>
	</div>
</template>

<script setup lang='ts'>

 import {ref,reactive,watch} from "vue";
 import { useI18n } from "vue-i18n";
 const { t, locale } = useI18n();
import { getLoginConfig } from "@/config/proConfig"
import type { proConfigItem } from '@/types/pro'
 import eventBus from "vue3-eventbus";
 import useUserStore from "@/store/modules/user";
 import useBaseStore from "@/store/modules/basic";
 import useProStore from "@/store/modules/pro";
 import {storeToRefs} from "pinia";

 const router = useRouter();
 const route = useRoute();
 const userStore = useUserStore();
 const userProStore = useProStore();
 const baseStore = useBaseStore();
 const { userInfo, token }  = storeToRefs(userStore);
 const { proConfig }  = storeToRefs(userProStore);
 const { languages, isChina}  = storeToRefs(baseStore);
const functionalAreaList = ref<proConfigItem[]>([]);

 const initList = () => {
	 functionalAreaList.value = getLoginConfig()
 }

 watch(locale,()=>{
	 initList();
 })
 onMounted(() => {
	 initList();

})

</script>

<style scoped lang='scss'>
.functionalArea{
	.functionArea_item{
		display: flex;
		align-items: center;
		padding:10px 0;
		.icon-icon_check2{
			color:#5C7AB0;
			margin-right:5px;
		}
		.functionArea_item_text{
			color:var(--text-color2);
			font-size: 14px;
		}
	}
}
</style>